module.exports = __webpack_public_path__ + "static/media/994077.ff830c8f.png";